import { env } from "environment-interface/env";
import { SubscriptionStatus } from "gql-types/schemas";
import { withBasePath } from "isomorphic/utils";
import { MessageStripe } from "prism-react";
import React from "react";

import { useCreateCustomerPortal } from "hooks/useCreateCustomerPortal";

export const PaymentPending: React.FC<{
  isTeamAdmin: boolean;
  status?: SubscriptionStatus;
  teamId?: string;
}> = ({ isTeamAdmin, teamId, status }) => {
  const customerPortal = useCreateCustomerPortal({
    // Only creates customer portal URL if the user is the team admin and
    // the payment is pending.
    teamId: isTeamAdmin ? teamId : null,
    returnPath: withBasePath(env, window.location.pathname),
  });

  const leading =
    status === SubscriptionStatus.Unpaid
      ? "There are some issues with your payment."
      : "Your payment was not yet approved.";

  const secondary = isTeamAdmin
    ? "Please check your payment details if the problem persists."
    : "Please contact your team admin to check the payment details.";

  if (isTeamAdmin) {
    return (
      <MessageStripe variant="warning">
        {leading}
        {secondary}
        {customerPortal.state === "READY" && (
          <MessageStripe.Action as="a" href={customerPortal.portalUrl}>
            Update payment
          </MessageStripe.Action>
        )}
      </MessageStripe>
    );
  }
  return (
    <MessageStripe variant="warning">
      {leading} {secondary}
    </MessageStripe>
  );
};
